import React from 'react'
export const SVG_BLOG = (
  <svg
    version='1.1'
    id='Capa_1'
    xmlns='http://www.w3.org/2000/svg'
    width='30'
    height='30'
    viewBox='0 0 512.069 512.069'
  >
    <path
      strokeWidth='20'
      d='M448.069,192.037c-11.093,0-21.333-3.563-21.333-29.333v-24
	C424.046,60.94,359.925-0.541,282.117,0.037H132.784C58.562,0.93-0.882,61.823,0.011,136.044c0.011,0.887,0.03,1.773,0.058,2.659
	V373.37c-2.362,74.189,55.866,136.247,130.056,138.608c0.886,0.028,1.773,0.048,2.659,0.058H355.44
	c89.301,0,156.629-62.485,156.629-145.323V256.037C512.069,208.186,495.92,192.037,448.069,192.037z M160.069,128.037h106.667
	c17.673,0,32,14.327,32,32s-14.327,32-32,32H160.069c-17.673,0-32-14.327-32-32S142.396,128.037,160.069,128.037z M352.069,384.037
	h-192c-17.673,0-32-14.327-32-32s14.327-32,32-32h192c17.673,0,32,14.327,32,32S369.742,384.037,352.069,384.037z'
    />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
)
